import { Text } from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps, Grid } from '@mantine/core'

import { InfoCardWithSmallIcon } from 'components/molecules/infoCardWithSmallIcon'

import useStyles from './index.styles'
import { useIsMobile } from 'hooks/useIsMobile'
import { SpotlightHealthToolListSession } from 'interfaces/types'

type Props = {
  title: string
  description: string
  data: SpotlightHealthToolListSession['healthTools']
  innerClass?: string
} & BoxProps

export const InfoCardWithSmallIconSection = ({
  title,
  description,
  data,
  innerClass,
  className,
  classNames,
  styles,
}: Props) => {
  const { classes, cx } = useStyles(undefined, {
    name: 'InfoCardWithSmallIconSection',
    styles,
    classNames,
  })
  const isMobile = useIsMobile()
  return (
    <Box className={cx(className, classes.root)}>
      <div className={cx(innerClass, classes.inner)}>
        {(title || description) && (
          <div className={classes.header}>
            {title && <h2 className={classes.heading}>{title}</h2>}
            {description && <div className={classes.desc}>{description}</div>}
          </div>
        )}
        <div className={classes.listing}>
          {data.map((i, idx: number) => (
            <div className={classes.group} key={idx}>
              <Text size={isMobile ? 's2' : 's1'}>{i.title}</Text>
              <Grid gutterSm={'sm'} gutterMd="xl">
                {i.listHealthTools.map((j, jidx: number) => (
                  <Grid.Col key={jidx} md={6} lg={4}>
                    <InfoCardWithSmallIcon
                      heading={j.title}
                      description={j.description}
                      thumbnail={j.icon}
                      url={j.url}
                      className={classes.item}
                    />
                  </Grid.Col>
                ))}
              </Grid>
            </div>
          ))}
        </div>
      </div>
    </Box>
  )
}
